var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-form"},[_c('h3',[_vm._v("Документы для этого приза предоставлены, ожидайте вручения")]),_c('v-btn',{on:{"click":function($event){_vm.$router.push({ name: 'prize' }).catch(() => {})}}},[_c('div',{staticClass:"btn-content-container"},[_vm._v("Вручение призов")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }